import React from 'react';
import PropTypes from 'prop-types';

export default function Star({ width, height }) {
  return (
   <svg
    height={height}
    width={width}
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
   >
    <path
     d="M4.50046 0.5L5.50557 3.61658L8.78021 3.60942L6.12676 5.52842L7.14549 8.64058L4.50046 6.71L1.85542 8.64058L2.87415 5.52842L0.220703 3.60942L3.49534 3.61658L4.50046 0.5Z"
     fill="white"
    />
   </svg>
  );
}

Star.propTypes = {
 width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
 height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
